import styled from "styled-components"

export const Wrapper = styled.div`
  background-color: #f7f9fa;
  display: block;
  min-height: 100vh;
  @media (max-width: 991.98px) {
    display: contents;
  }
`

export const Header = styled.div`
  height: 40px;
  margin: 12px 20px 0 20px;
  border-bottom: 1px solid #3a94df;
  @media (max-width: 991.98px) {
    margin: 12px 10px 0 10px;
  }
`

export const Title = styled.h1`
  display: initial;
  color: #3a94df;
  font-weight: 700;
  background-color: #f7f9fa;
  margin: 0;
  padding-right: 10px;
`
